module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showGetrank = true) && (_vm.neuGetrank = true) && (_vm.getrank = [])
            }
          }
        }, [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Erstellen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "height": _vm.sideHeight,
      "headers": _vm.headers,
      "items": _vm.getranke,
      "search": _vm.search,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "no-data-text": "Keine Getränke vorhanden"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th', [_vm._v("Was")]), _vm._v(" "), _c('th', [_vm._v("Einkaufspreis")])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          class: !item.switchZahlung ? 'red lighten-4' : '',
          on: {
            "dblclick": function($event) {
              (_vm.getrank = item) && (_vm.showGetrank = true) && (_vm.neuGetrank = false)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', {
          staticClass: "text-right"
        }, [_vm._v(_vm._s(_vm._f("money")(item.preis)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(item.verkaufseinheit))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(_vm._f("money")(item.verkauf1)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(_vm._f("money")(item.verkauf2)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right hidden-xs-only"
        }, [_vm._v(_vm._s(_vm._f("money")(item.verkauf3)))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "70%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showGetrank),
      callback: function($$v) {
        _vm.showGetrank = $$v
      },
      expression: "showGetrank"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', [(_vm.neuGetrank) ? _c('div', {
    staticClass: "pr-1"
  }, [_vm._v("Neues Getränk erstellen")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.getrank.bezeichnung) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrank = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-app-bar', {
    staticClass: "transparent",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.num),
      callback: function($$v) {
        _vm.num = $$v
      },
      expression: "num"
    }
  }, [_c('v-tab', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("info")]), _vm._v("Info")], 1), _vm._v(" "), (!_vm.neuGetrank) ? _c('v-tab', [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("insights")]), _vm._v("Statistik")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-tabs-items', {
    model: {
      value: (_vm.num),
      callback: function($$v) {
        _vm.num = $$v
      },
      expression: "num"
    }
  }, [_c('v-tab-item', [_c('v-row', {
    staticClass: "pa-0 ma-0 mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Bezeichnung"
    },
    model: {
      value: (_vm.getrank.bezeichnung),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "bezeichnung", $$v)
      },
      expression: "getrank.bezeichnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Flaschen/Gebinde",
      "hint": "Anzahl Flaschen pro Kiste"
    },
    model: {
      value: (_vm.getrank.verkaufseinheit),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkaufseinheit", $$v)
      },
      expression: "getrank.verkaufseinheit"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Volumen/Flasche"
    },
    model: {
      value: (_vm.getrank.volumen),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "volumen", $$v)
      },
      expression: "getrank.volumen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Preis/Gebinde inkl. MwSt."
    },
    model: {
      value: (_vm.getrank.preis),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "preis", $$v)
      },
      expression: "getrank.preis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Preis/Gebinde exkl. MwSt.",
      "disabled": ""
    },
    model: {
      value: (_vm.preisexcl),
      callback: function($$v) {
        _vm.preisexcl = $$v
      },
      expression: "preisexcl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Pfand",
      "hint": "Für eine Kiste"
    },
    model: {
      value: (_vm.getrank.pfand),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "pfand", $$v)
      },
      expression: "getrank.pfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Striche pro Flasche"
    },
    model: {
      value: (_vm.getrank.striche),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "striche", $$v)
      },
      expression: "getrank.striche"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Verkaufspreis 1",
      "hint": "Wird für EKP verwendet"
    },
    model: {
      value: (_vm.getrank.verkauf1),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkauf1", $$v)
      },
      expression: "getrank.verkauf1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Verkaufspreis 2",
      "hint": "Kann in Abrechnungen verwendet werden"
    },
    model: {
      value: (_vm.getrank.verkauf2),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkauf2", $$v)
      },
      expression: "getrank.verkauf2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Verkaufspreis 3",
      "hint": "Kann in Abrechnungen verwendet werden"
    },
    model: {
      value: (_vm.getrank.verkauf3),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "verkauf3", $$v)
      },
      expression: "getrank.verkauf3"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "6",
      "lg": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "outlined": "",
      "items": _vm.kategorien,
      "label": "Standard"
    },
    model: {
      value: (_vm.getrank.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "kategorie", $$v)
      },
      expression: "getrank.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "Pfand zählen"
    },
    model: {
      value: (_vm.getrank.switchPfand),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchPfand", $$v)
      },
      expression: "getrank.switchPfand"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "EKP erlauben"
    },
    model: {
      value: (_vm.getrank.switchEkp),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchEkp", $$v)
      },
      expression: "getrank.switchEkp"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "Getränk kann bestellt werden"
    },
    model: {
      value: (_vm.getrank.switchBestellung),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchBestellung", $$v)
      },
      expression: "getrank.switchBestellung"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "label": "Getränk kann gezählt werden"
    },
    model: {
      value: (_vm.getrank.switchZahlung),
      callback: function($$v) {
        _vm.$set(_vm.getrank, "switchZahlung", $$v)
      },
      expression: "getrank.switchZahlung"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.neuGetrank) ? _c('v-tab-item', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pt-8 pb-0 mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-slider', {
    attrs: {
      "max": "24",
      "min": "1",
      "thumb-size": 24,
      "thumb-label": "always",
      "ticks": "always",
      "tick-size": "4"
    },
    model: {
      value: (_vm.anzahl),
      callback: function($$v) {
        _vm.anzahl = $$v
      },
      expression: "anzahl"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-1 px-2"
  }, [_vm._v("\n                    Verbraucht\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("Ø\n                      " + _vm._s((
    (_vm.statistiken.verbraucht.data.reduce(function (a, b) { return a + b; }, 0) /
      _vm.statistiken.verbraucht.data.length) *
    _vm.getrank.volumen
  ).toFixed(1)) + "\n                      l")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, _vm._l((_vm.statistiken.verbraucht.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "16",
        "value": (item / Math.max.apply(Math, _vm.statistiken.verbraucht.data)) * 100
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(_vm.statistiken.monate[index], "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s((item * _vm.getrank.volumen).toFixed(0)) + " l")])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-1 px-2"
  }, [_vm._v("\n                    EKP\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("Ø\n                      " + _vm._s((
    (_vm.statistiken.ekp.data.reduce(function (a, b) { return a + b; }, 0) / _vm.statistiken.ekp.data.length) *
    _vm.getrank.volumen
  ).toFixed(1)) + "\n                      l")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, _vm._l((_vm.statistiken.ekp.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "16",
        "value": (item / Math.max.apply(Math, _vm.statistiken.ekp.data)) * 100
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(_vm.statistiken.monate[index], "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s((item * _vm.getrank.volumen).toFixed(0)) + " l")])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "ma-0 py-1 px-2"
  }, [_vm._v("\n                    Ende\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("Ø\n                      " + _vm._s((
    (_vm.statistiken.ende.data.reduce(function (a, b) { return a + b; }, 0) / _vm.statistiken.ende.data.length) *
    _vm.getrank.volumen
  ).toFixed(1)) + "\n                      l")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, _vm._l((_vm.statistiken.ende.data), function(item, index) {
    return _c('v-progress-linear', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "rounded": "",
        "height": "16",
        "value": (item / Math.max.apply(Math, _vm.statistiken.ende.data)) * 100
      }
    }, [_c('v-row', {
      staticClass: "mx-2",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s(_vm.$filters.date(_vm.statistiken.monate[index], "MM.YY")))]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(_vm._s((item * _vm.getrank.volumen).toFixed(0)) + " l")])], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrank = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.neuGetrank) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createGetrank()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateGetrank()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteGetrank,
      "title": "Getränk löschen",
      "message": "Willst du dieses Getränk wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteGetrank = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteGetrank()
      },
      "closeFalse": function($event) {
        _vm.showDeleteGetrank = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c65f2006"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/bierwartGetranke.vue
// module id = 810
// module chunks = 15